import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import utilities from "./utilities/utility";
import configUtilities from "./utilities/configUtility";
import fb from "./firebaseConfig.js";
import store from "./store";
import { firestorePlugin } from "vuefire";
import VueTheMask from "vue-the-mask";
import vSelect from "@/components/VSelectAll.vue";
import Upload from "@/components/Upload.vue";
import Loading from "vue-loading-overlay";
import VueTelInput from 'vue-tel-input'
import "vue-loading-overlay/dist/vue-loading.css";
import "./registerServiceWorker";

Vue.component("v-select", vSelect);
Vue.use(VueTheMask);
Vue.use(VueTelInput, {
  mode: "international",
  disabledFetchingCountry: true,
  disabled: false,
  disabledFormatting: false,
  placeholder: "Enter a phone number",
  required: false,
  enabledCountryCode: false,
  enabledFlags: true,
  preferredCountries: ["US", "CA"],
  autocomplete: "on",
  name: "telephone",
  maxLen: 15,
  wrapperClasses: "",
  inputClasses: "international-input",
  dropdownOptions: {
    disabledDialCode: false
  },
  inputOptions: {
    showDialCode: true
  }
})
Vue.use(Loading);
Vue.use(require("vue-moment"));
Vue.use(firestorePlugin);
Vue.component("file-upload", Upload);
Vue.mixin(utilities.mixin());
Vue.mixin(configUtilities.mixin());
Vue.config.productionTip = false;

let app;
fb.auth.onAuthStateChanged(async (user) => {
  if (user) {
    store.commit("setUser", user);
    await store.dispatch("getUserDoc", user.uid);
  }
  if (!app) {
    app = new Vue({
      store: store,
      router,
      render: (h) => h(App),
      async created() {
        this.$store.dispatch("setPlans");
      },
    }).$mount("#app");
  }
});
